// every internal link starts with $url. and closed with $
// every internal link has to contain at least one word: $url.parameter$
// an internal link might contain a second word: $url.workspace.create$
// an internal link might contain one or more number after one or more words:
// $url.item.456$
// $url.report.execute.456$
// $url.smartlist.456.123$
// $url.actionbutton.concept.456.123$
// an internal link can contain a label, which will become the name text content of the link
// $url.item.456#This is the content for the link$

export const externalLinksRegex =
    /\b((?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#/%=~_|$?!:,.]*\)|[A-Z0-9+&@#/%=~_|$/]))/gi

export const localFilePathRegex =
    /\b\p{Letter}:[\\](?:[^\\/:*?"<>|\r\n\s]+[\\])*[^\\/:*?"<>|\r\n\s]*\b/gu

export const UNCFilePathRegex =
    /\\\\(?:\?\\UNC\\)?[\p{Letter}\p{Number}._%~-]+\\[\p{Letter}\p{Number}._%~-]+(?:\\[\p{Letter}\p{Number}._%~-]+)*/gu

// for this weird regex, the actual regex is /\$url(?:\.\w+)+(?:#([^\s$\p{Separator}\p{Control}][^$]*))/gu look up lookarounds in regexes, we have it here to make sure there are no [a-zA-z0-9_] characters right before or behind the url
export const internalLinksRegex =
    /(?<!\w)\$url(?:\.\w+)+(?:#([^\s$\p{Separator}\p{Control}][^$]*))?\$(?!\w)/gu

export const TRAILING_PUNCT = /[.,;:!?)\]}'"]+$/
/* ==================================================================
 * Sentinel constants
 *
 * We use independent sentinel systems:
 *   - IL sentinels: placeholders for internal $url.*$ tokens
 *   - PROT sentinels: placeholders for HTML elements we must protect
 *                     from urlify (iframes, images, scripts' bodies, etc.)
 *
 * Both use \u0000 (null char) as the boundary because it never appears
 * in real HTML and no regex in urlify matches it.
 * ================================================================== */
export const IL_SENTINEL_START = "\u0000IL:"
export const IL_SENTINEL_END = "\u0000"

export const PROT_SENTINEL_START = "\u0000PROT:"
export const PROT_SENTINEL_END = "\u0000"

export const SENTINEL_START = "\u0000FTLINK:"
export const SENTINEL_END = "\u0000"

/* ==================================================================
 * Tags whose *content* must not be text-walked or urlified.
 *
 * These contain code, literal text, or CSS. Rewriting them breaks the
 * rendered page. They are pulled out of the DOM, replaced with a
 * sentinel, and restored after urlify.
 *
 * <script> is handled separately: it must also be moved to
 * <div id="script"> so the browser can execute it after injection.
 * ================================================================== */

export const RAW_CONTENT_TAGS = [
    "style",
    "textarea",
    "pre",
    "code",
    "samp",
    "kbd",
    "var",
    "noscript",
    "template",
    "svg",
    "math",
]

/* ==================================================================
 * Tags that carry URLs in attributes and must not be touched by
 * urlify (which runs over the whole HTML string, including attributes).
 * ================================================================== */
export const URL_ATTR_TAGS = [
    "iframe",
    "img",
    "video",
    "audio",
    "source",
    "track",
    "embed",
    "object",
    "picture",
    "form",
    "input",
    "button",
    "blockquote",
    "q",
    "del",
    "ins",
]
